import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    count: 0
  },
  mutations: {
    focus (state) {
      state.count = 1;
    },
    blur(state){
      state.count = 0
    }
  }
})

export default {
  store
}


// WEBPACK FOOTER //
// ./src/utils/store.js